import { defineRouting } from 'next-intl/routing'

import { defaultLocale, locales } from './locales'

export const routing = defineRouting({
    locales: [...locales],
    defaultLocale,
    // We do not locale-detect unprefixed entry points. Which locale an unprefixed
    // path renders as is `src/proxy.ts`'s decision (the bare host `/` is the default
    // locale unconditionally). Disabling detection makes that explicit and keeps
    // `/` from silently resurrecting a cookie/Accept-Language redirect if the proxy
    // carve-out is ever changed.
    localeDetection: false,
    // With detection off nothing reads NEXT_LOCALE, and a Set-Cookie on a page
    // response would both fail the PCI scan (no `Secure`) and stop Cloudflare
    // caching it.
    localeCookie: false,
})

export type Locale = (typeof routing.locales)[number]
